import { ApiStandardResponse, IApiStandardResponse } from "@/core/models/api/api.models";

export interface ILoginCredentials {
  username: string;
  password: string;
  device_name?: string;
}

export class LoginCredentials {
  username: string;
  password: string;
  device_name?: string;

  constructor(credentials: ILoginCredentials) {
    this.username = credentials.username;
    this.password = credentials.password;
    this.device_name = credentials.device_name;
  }

  toJson(): ILoginCredentials {
    return {
      username: this.username,
      password: this.password,
      device_name: this.device_name
    };
  }

  toFormData(): FormData {
    const formData = new FormData();
    formData.append('username', this.username);
    formData.append('password', this.password);
    if (this.device_name) {
      formData.append('device_name', this.device_name);
    }
    return formData;
  }
}

export interface ILoginResponse {
  token_id: string;
  token: string;
  token_exiration_minutes: string;
  refresh_token: string;
  token_type: string;
}

/** App di provenienza inviata al backend nel reset password. */
export const RESET_PWD_APP_SOURCE = 'premi';

export interface IResetPWD {
  username: string;
  device_name: string;
  app_source?: string;
}

export interface IResetPWDResponse extends IApiStandardResponse<string> {};

export interface ITokenData {
    token_id: string;
    token: string;
    token_expiration_minutes: string;
    refresh_token: string;
    token_type: string;
}

export interface IToken {
  token_id: string;
  token: string;
  token_expiration_minutes: string;
  refresh_token: string;
  token_type: string;
}

export interface IApiToken extends IApiStandardResponse<IToken> {};

/** Token restituito da exchange-ticket (SSO). Nessun refresh_token. */
export interface ISSOToken {
    token_id: number;
    token: string;
    token_type?: string;
}

export interface IExchangeTicketRequest {
    ticket: string;
    /** ID profilo (multiutenza), obbligatorio per exchange-ticket. Passato da Auth-App via query id_profilo. */
    id_profilo: number;
    /** Device name/id usato per generare token Sanctum per questo client. */
    device_name?: string;
}

/**
 * Request per l'endpoint SSO `sso/exchange-ticket-no-profile`.
 * Non richiede id_profilo perché usato nel flusso \"senza profilo\".
 */
export interface IExchangeTicketNoProfileRequest {
    ticket: string;
    /**
     * Alcuni backend potrebbero richiedere esplicitamente la target app
     * anche per il flusso senza profilo.
     */
    target_app?: string;
    /** Device name/id usato per generare token Sanctum per questo client. */
    device_name?: string;
}

export interface IApiExchangeTicketResponse extends IApiStandardResponse<ISSOToken> {}
